import React, { createContext, useCallback, useContext, useRef, type ReactNode } from 'react';

import { useMessageViewed } from './index';

const MessageDisplayedContext = createContext<(() => void) | undefined>(undefined);

/** Defers viewed and delivery events until a host confirms display. */
export const HostMessageDisplayProvider = ({ children }: { children: ReactNode }): JSX.Element => {
	const messageViewed = useMessageViewed();
	const hasDisplayed = useRef(false);
	const recordDisplay = useCallback(() => {
		if (hasDisplayed.current) {
			return;
		}

		hasDisplayed.current = true;
		void messageViewed();
	}, [messageViewed]);

	return (
		<MessageDisplayedContext.Provider value={recordDisplay}>
			{children}
		</MessageDisplayedContext.Provider>
	);
};

/** Call after the host confirms that the message UI has been displayed. */
export const useMessageDisplayed = (): (() => void) | undefined =>
	useContext(MessageDisplayedContext);
